var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{class:_vm.pathClasses,attrs:{"d":_vm.pathDrawn,"transform":_vm.centerTransform}})
}
var staticRenderFns = []

export { render, staticRenderFns }